/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm, replacePXinStringWithEM } from '@insticator/insticator-ui'; // iui-utils


/* ++++++++++ --------------- EXPORT : EMBED ANALYTICS : STYLES --------------- ++++++++++ */
export default {
    embedAnalytics: {
        '& .page': {
            width: '100%'
        },
        '& #main': {
            display: 'flex',
            flexWrap: 'wrap'
        }
    }
};
